// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-fb4583de]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.recharge-edit__list .item[data-v-fb4583de]{background-color:hsla(0,0%,100%,.05);margin-bottom:16px;padding:12px 10px 12px 8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
